// extracted by mini-css-extract-plugin
module.exports = {"page":"TextPage_page__3rpDT","limiter":"TextPage_limiter__1kXl6"};